<template>
  <div class="fl edmodo-footer-lang">
      <section class="fusion-footer-widget-column widget widget_media_image">
        <!-- <img width="250" height="54" :src="edmodo" sizes="(max-width: 250px) 100vw, 250px"/> -->
        <img width="250" height="54" src="https://9kyhf3crb4ah2d0m726aoc6x-wpengine.netdna-ssl.com/wp-content/uploads/2019/06/hybridArtboard-5@2x.png" class="image wp-image-1533  attachment-full size-full" alt="" style="max-width: 100%; height: auto;" srcset="https://9kyhf3crb4ah2d0m726aoc6x-wpengine.netdna-ssl.com/wp-content/uploads/2019/06/hybridArtboard-5@2x-200x43.png 200w, https://9kyhf3crb4ah2d0m726aoc6x-wpengine.netdna-ssl.com/wp-content/uploads/2019/06/hybridArtboard-5@2x.png 250w" sizes="(max-width: 250px) 100vw, 250px">
        <div style="clear:both;"></div>
      </section>
      <section id="custom_html-2" class="widget_text fusion-footer-widget-column widget widget_custom_html">
        <div class="textwidget">
          <p v-text="this.$t('txt_0037')"></p>
          <p class="edmodo" v-text="'Edmodo © ' + year"></p>
          <div style="clear:both;"></div>
        </div>
        <div style="clear:both;"></div>
      </section>
      <!-- <language-picker v-if="$route.name !== 'edo_app'"></language-picker> -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      edmodo: require('../../../assets/logo.png')
    }
  },
  computed: {
    year () {
      return new Date().getFullYear()
    }
  },
  methods: {
    init () {

    }
  },
  components: {
    languagePicker: () => import('./languagePicker')
  }
}
</script>

<style scoped>
section {
  min-height: 26px; /*no*/
}
.edmodo-footer-lang {
  width: 34%;
  padding: 0 15px; /*no*/
  padding-left: 0;
}
.fusion-footer-widget-column {
  margin-bottom: 50px; /*no*/
  font-size: 16px; /*no*/
}
.fusion-footer-widget-column img {
  max-width: 120px!important; /*no*/
  height: auto;
  vertical-align: top;
  float:left;
}
#custom_html-2 {
  font-family: "Disclaimer";
}
p {
  font: 13px/20px PTSansRegular,Arial,Helvetica,sans-serif; /*no*/
  font-size: 16px; /*no*/
  color: #777;
  margin: 16px 0; /*no*/
  font-weight: 400;
  letter-spacing: 0px;
  font-style: normal;
  font-family: "Disclaimer";
}
.edmodo {
  line-height: 20px; /*no*/
}
@media only screen and ( max-width: 768px) {
  section {
    min-height: 26px;
  }
  .edmodo-footer-lang {
    width: 100%;
    padding: 0 15px;
    padding-left: 0;
  }
  .fusion-footer-widget-column {
    margin-bottom: 50px;
    font-size: 16px;
  }
  .fusion-footer-widget-column img {
    max-width: 180px!important;
    height: auto;
  }
  p {
    font-size: 14px; /*no*/
    line-height: 16px; /*no*/
    margin: 16px 0;
    letter-spacing: 0px;
  }
  .edmodo {
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// lang.vue?1658d01c